import type { Point } from '@/lib/shapes/shape-coordinates'

/**
 * Convert a point in this layer's coordinate space into client (viewport) coordinates.
 *
 * The host `<svg>` carries no `viewBox` and no transform, so one user unit is one CSS pixel and its
 * user-space origin is its own top-left — the conversion is a straight offset by the element's
 * bounding rect. Returns `undefined` if the SVG can't be reached, letting the caller fall back.
 */
export function toClientPoint(
  element: SVGElement,
  point: { x: number; y: number }
): { x: number; y: number } | undefined {
  const svg = element.ownerSVGElement

  if (!svg) return undefined

  const rect = svg.getBoundingClientRect()

  return { x: rect.left + point.x, y: rect.top + point.y }
}

/** An SVG `points` attribute: `x,y` pairs separated by spaces. */
export function formatPolygonPoints(points: ReadonlyArray<Point>): string {
  return points.map((p) => `${p.x},${p.y}`).join(' ')
}
